export enum ProductUnit {
    L = 'L',
    KG = 'KG',
    MT = 'MT',
    BARREL = 'BARREL',
    MWH = 'MWH',
    MMBTU = 'MMBTU',
    PIECE = 'PIECE',
}
